import { Box, Button, CssBaseline, Grid2, Paper } from "@mui/material";
import * as React from "react";
import logosf from "../images/logoDLS.jpg";
import banner from "../images/LONGBANNER.jpg";
import banner2 from "../images/Banner2.png";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import image09 from "../images/image009.jpg";
import image08 from "../images/image008.jpg";
import image04 from "../images/image004.jpg";

function Videos() {
  return (
    <Box
      sx={{
        width: "auto",
        display: "block",
      }}
    >
      <Box>
        <Grid2 container>
          <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
            <Box
              sx={{
                background: "#009999",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={banner2}
                alt="Digital Language Services"
                className="img-dim-banner"
              />
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 6 }}>
            <Box
              sx={{
                background: "#009999",
                display: "flex",
                width: "100%",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  background: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: "100%",
                  padding: "20px 0",
                  clipPath: {
                    xs: "none",
                    sm: "none",
                    md: "polygon(10% 0, 100% 0, 100% 100%, 0% 100%)",
                  },
                }}
              >
                <img
                  src={logosf}
                  alt="Digital Language Services"
                  className="img-dim-logo"
                />
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          paddingTop: "45px",
          fontWeight: "bold",
          fontSize: "22px",
          color: "#077f83",
        }}
      >
        SIGUENOS EN NUESTRO CANAL DE YOUTUBE
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: {
              xs: "100vw",
              sm: "90vw",
              md: "70vw",
            },
            display: "block",
            textAlign: "justify",
          }}
        >
          <Box p={3}>
            <Box>
              <Box
                sx={{
                  display: "block",
                  textAlign: "center",
                }}
              ></Box>
            </Box>
          </Box>
          <Grid2 container spacing={1} sx={{ width: "70vw" }}>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
              <Box p={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <iframe
                    width="100%"
                    height="360px"
                    src="https://www.youtube.com/embed/1tpckKlwwmQ"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
              <Box p={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <iframe
                    width="100%"
                    height="360px"
                    src="https://www.youtube.com/embed/8NBhJ3lDj08"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
              <Box p={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <iframe
                    width="100%"
                    height="360px"
                    src="https://www.youtube.com/embed/MmvE-6j6R3k"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
              <Box p={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <iframe
                    width="100%"
                    height="360px"
                    src="https://www.youtube.com/embed/ngu-9I-gKyc"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
              <Box p={1}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <iframe
                    width="100%"
                    height="360px"
                    src="https://www.youtube.com/embed/WRePmhpGabw"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </Box>
  );
}

export default Videos;
